<div class="inline-load-error" role="alert">
  <p>{{ message }}</p>
  <div class="inline-load-error__actions">
    @if (retryable) {
    <button mat-stroked-button type="button" (click)="retry.emit()" i18n>Opnieuw proberen</button>
    } @if (reportable) {
    <button mat-button type="button" (click)="reportError()" i18n>Fout melden</button>
    }
  </div>
</div>
